module.exports = __webpack_public_path__ + "img/logo.e23c90bd.png";